module.exports = __webpack_public_path__ + "static/media/bg_d.10990bed.jpg";